import React from 'react';
import {UseFormRegister} from 'react-hook-form';
import {useSelector} from 'react-redux';
import cn from 'classnames';

import PremiumCheckbox from 'shared/ui/Checkbox/PremiumCheckbox/PremiumCheckbox';
import {getDomainCheckFeatures} from 'entities/monitor';
import {hasTariffFlag, useIsFreeTariff, userSelector} from 'entities/user';
import {isTranslate} from 'shared/lib/lang';

import FieldCard from '../FieldCard/FieldCard';

import styles from '../CheckboxBlock.module.scss';

interface IDomainChecksBlockProps {
    register: UseFormRegister<any>,
    disabledKeys?: string[],
    disabledHint?: string,
}

const DomainChecksBlock: React.FC<IDomainChecksBlockProps> = ({register, disabledKeys, disabledHint}) => {
    const user = useSelector(userSelector);
    const freeTariff = useIsFreeTariff();

    return (
        <div className={cn(styles.container, freeTariff && styles.freeContainer)}>
            {getDomainCheckFeatures()
                .filter(feature => !(isTranslate() && feature.name === 'rkn_watch'))
                .map(feature => {
                    const isDisabled = disabledKeys?.includes(feature.name) ?? false;

                    return (
                        <FieldCard key={feature.name} selective={false} freeTariff={freeTariff}>
                            <PremiumCheckbox
                                label={feature.label}
                                helpText={feature.help}
                                register={register(feature.name)}
                                enabled={hasTariffFlag(user, feature.condition)}
                                disabled={isDisabled}
                            />
                            {isDisabled && disabledHint && (
                                <p className={styles.methodHint}>{disabledHint}</p>
                            )}
                        </FieldCard>
                    );
                })}
        </div>
    );
};

export default React.memo(DomainChecksBlock);
